import api from './api';

export const billingAPI = {
  getPaymentMethods: () => api.get('/billing/payment-methods'),
  createSetupIntent: () => api.post('/billing/setup-intent'),
  createPaymentIntent: (data) => api.post('/billing/payment-intent', data),
};

export default billingAPI;